var ContextMenu;

(function ($) {

  var panel = $('<div id="mainContextMenuContainer" class="contextmenu-container contextmenu-container__hidden stat_ContextMenu"></div>');
  var init = false;
  var panel_added = false;
  var scrollStep = 25;

  function ensurePanelAdded() {
    if (!panel_added) {
      panel_added = true;
      $("body").append(panel.mousedown(function (ev) { ev.stopPropagation() }));
    }
  }

  function showPanel(panel) {
    panel.removeClass("contextmenu-container__hidden").redraw();
  }

  function hidePanel(panel) {
    if (!panel.hasClass("contextmenu-container__hidden")) {
      panel.addClass("contextmenu-container__hidden");
      if (panel.data('contextMenu') && panel.data('contextMenu').onHide) {
        panel.data('contextMenu').onHide.call(panel.data('contextMenu'));
      }
    }
  }

  function hideAllPanels() {
    $('.contextmenu-container').each(function () {
      hidePanel($(this));
    });
  }

  function getOffset(elem) {
    return elem.offset();
  }

  function doInit() {
    $(function () {
      if (!$.ipad)
        $("body").mousedown(function () { ContextMenu.hide(); });
    })
  }

  $.fn.contextMenu = function (menu, eventName) {
    if (typeof eventName == "undefined")
      eventName = "click";
    $(this).off(eventName).on(eventName, function () { menu.toggle(this, panel) });
    return this;
  }

  var defaults = {
    width: 200,
    arrowWidth: 15,
    shiftX: 0,
    shiftY: 20,
    cssClass: "",
    arrowImage: "ArrowRight.png"
  }

  ContextMenu = function (items, options) {
    if (!init) {
      init = true;
      doInit();
    }
    this.items = items;
    $.extend(this, defaults, options);
  }

  ContextMenu.hide = function (el) {
    var p = panel;
    if (el) p = $(el).parents('div.contextmenu-container').first();
    hidePanel(p);
  }

  ContextMenu.hideAll = function () {
    hideAllPanels();
  }

  $.extend(ContextMenu.prototype, {
    toggle: function (elem, _panel) {
      if (typeof _panel == "undefined")
        _panel = panel;
      ensurePanelAdded();
      if (!panel.hasClass("contextmenu-container__hidden")) {
        hidePanel(_panel);
      }
      else
        this.show(elem, _panel);
    },
    show: function (elem, _panel, opt_event) {
      this.targetElement = elem;

      var el = $(elem);
      if (scrollStep < 0) scrollStep = -scrollStep;
      if (typeof _panel == "undefined")
        _panel = panel;
      this.lastPanel = _panel;
      this.lastElement = el;
      _panel = $(_panel);
      ensurePanelAdded();
      _panel.data('contextMenu', this);
      this.fillContainer(_panel, opt_event);
      var coords = this.getCoordsFor(getOffset(el), _panel, true);
      coords.top = Math.floor(coords.top);
      //logDebug(coords.top);
      if (coords.top < 0) coords.top = 10;
      this.tuneContainer(_panel, coords, true);
      if (this.onShow) {
        var ok = this.onShow.call(this);
        if (ok === false)
          return;
      }
      if ($.ipad) {
        $('html').one('mousedown', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          $('.contextmenu__manualhide').click();
        });
      }
      showPanel(_panel);
    },

    showAt: function (coords, _panel, isInternal, opt_event) {

      if (scrollStep < 0) scrollStep = -scrollStep;
      if (!_panel)
        _panel = panel;
      this.lastPanel = _panel;
      ensurePanelAdded();
      _panel.data('contextMenu', this);
      this.fillContainer(_panel, opt_event);
      coords.left -= defaults.shiftX;
      coords.top -= defaults.shiftY;
      coords.left += this.shiftX;
      coords.top += this.shiftY;
      if (!isInternal) {
        coords = this.getCoordsFor(coords, _panel, false);
      }
      if (coords.top < 0) coords.top = 10;
      this.tuneContainer(_panel, coords);
      if (this.onShow) {
        var ok = this.onShow.call(this);
        if (ok === false)
          return;
      }
      //Задержка требуется для IE
      setTimeout(function () {
        showPanel(_panel);
      }, 0);
    },

    fillContainer: function (_panel, event) {

      var scroller = $('<div />', { id: "menuscroller", style: "overflow: auto;" });
      var imageArrowUp = $('<img src="/App_Sprites/ArrowScrollUp.png">').css('background', 'silver').css('cursor', 'pointer');
      var divArrowUp = $('<div id="arrowUp"></div>').css('position', 'fixed').hide();
      divArrowUp.append(imageArrowUp);

      scroller.html(this.render(_panel, $.ipad, event));
      var imageArrowDown = $('<img src="/App_Sprites/ArrowScroll.png">').css('background', 'silver').css('cursor', 'pointer');
      var divArrowDown = $('<div id="arrowDown"></div>').css('position', 'fixed').hide();
      divArrowDown.append(imageArrowDown);
      _panel.html(divArrowUp).append(scroller).append(divArrowDown).css('height', scroller.height());
    },

    tuneContainer: function (_panel, coords) {
      var scroller = $('#menuscroller', _panel);
      var divArrowDown = $('#arrowDown', _panel);
      var divArrowUp = $('#arrowUp', _panel);
      var imageArrowDown = divArrowDown.find('img');
      var imageArrowUp = divArrowUp.find('img');

      var wheel = function (e) {
        var scroller = $('#menuscroller');
        var delta = 0;
        e = e ? e : window.event;
        // Установим кроссбраузерную delta
        if (e.wheelDelta) {
          // IE, Opera, safari, chrome - кратность дельта равна 120
          delta = e.wheelDelta / 120;
        } else if (e.detail) {
          // Mozilla, кратность дельта равна 3
          delta = -e.detail / 3;
        }

        var cancelEvent = function (e) {
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          if (e.preventDefault) {
            e.preventDefault();
          }
          e.cancelBubble = true;
          e.cancel = true;
          e.returnValue = false;
          return false;
        };

        scroller.scrollTop(scroller.scrollTop() - 20 * delta);
        return cancelEvent(e);
      };

      if (coords.top >= 34) {
        var top = coords.top;
        if (top + _panel.height() + 34 > window.innerHeight) top -= (top + _panel.height() - window.innerHeight) + 40;
        _panel.attr('style', '').css({ left: coords.left + "px", top: top + "px" });
        scroller.attr('style', '');
        divArrowDown.hide();
        divArrowUp.hide();
        if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', wheel, false);
        window.onmousewheel = document.onmousewheel = null;
      } else {
        if (_panel.height() > $(window).height() - 10) { // если контекстное меню не влазит в окно, то урезаем его
          _panel.css({
            left: coords.left + "px",
            top: "15px",
            height: $(window).height() - 20 + "px",
            position: "fixed",
            overflow: "hidden"
          });
          imageArrowDown.css({ width: _panel.width(), background: "silver" }).show();
          imageArrowUp.css({ width: _panel.width(), background: "silver" }).show();
          if (!$.ipad) {
            divArrowDown.css({ position: "fixed", top: _panel.height() + 7 + "px" }).show();
            divArrowUp.css({ position: "fixed", top: 7 + "px" }).show();
            scroller.css({ overflow: "hidden", height: _panel.height() });
            if (window.addEventListener) window.addEventListener('DOMMouseScroll', wheel, false);
            window.onmousewheel = document.onmousewheel = wheel; // IE, Opera.
          } else {
            var padding = WA.ENV.isAndroid() ? Math.max(0, coords.left - _panel.width() - 5) : coords.left + 25;
            _panel.attr('style', '').css({ left: padding + "px", top: "10px" });
            _panel.css('height', $(window).height() - 20 + "px");
            divArrowDown.css({ position: "fixed", top: _panel.height() + "px" }).show();
            divArrowUp.css({ position: "fixed", top: 8 + "px" }).css('z-index', '100000').show();
            scroller.css({ overflow: "auto", paddingTop: "5px", height: _panel.height() - 10, width: $(window).width() + 100 }).addClass('contextmenu_scroller');
            if (!WA.ENV.isAndroid()) var contextMenuScroll = new iScroll('menuscroller', { useTransform: true });
            if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', wheel, false);
            window.onmousewheel = document.onmousewheel = null;
          }
        } else { // иначе просто сдвигаем
          var padding = WA.ENV.isAndroid() ? Math.max(0, coords.left - _panel.width() - 5) : coords.left + 25;
          _panel.attr('style', '').css({ left: padding + "px", top: "10px" });
          scroller.attr('style', '');
          divArrowDown.hide();
          divArrowUp.hide();
          if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', wheel, false);
          window.onmousewheel = document.onmousewheel = null;
        }
      }

      scroller.scroll(wheel);
      divArrowDown.click(function (ev) {
        scroller.scrollTop(scroller.scrollTop() + scrollStep);
      });
      divArrowUp.click(function (ev) {
        scroller.scrollTop(scroller.scrollTop() - scrollStep);
      });
      var autohide;
      $('.contextmenu-container')
        .off('mouseenter.contextmenu')
        .off('mouseleave.contextmenu')
        .on('mouseenter.contextmenu', function () { if (autohide) clearTimeout(autohide); })
        .on('mouseleave.contextmenu', function (ev) {
          var jContainer = $(this);

          var target = ev.target;
          // IE10 наведение на SVG внутри меню воспринимает как уход с контекстного меню и вызывает это событие.          
          // В IE10 c SVG работать надо не так как обычно https://stackoverflow.com/questions/33672395/use-within-svg-not-finding-closest-div-in-ie
          if (target.correspondingUseElement) {
            return;
          } 

          var jContextMenuTable = jContainer.find('table.contextmenu');
          autohide = setTimeout(function () {
            ContextMenu.hide(jContextMenuTable);
            if (window.addEventListener) window.removeEventListener('DOMMouseScroll', wheel, false);
            window.onmousewheel = document.onmousewheel = null;
          }, 500);

        });
    },

    render: function (_panel, isTablet, event) {
      var body = $("<table cellspacing='0' cellpadding='0' class='contextmenu'></table>").addClass(this.cssClass).css('width', this.width);
      if (this.id)
        body.attr("id", this.id);
      var _this = this;
      $.each(_this.items,
        function () {
          body.append($("<tr></tr>").append($("<td></td>").append(_this.renderItem(this, _panel, $.ipad, event))));
        });
      if ($.ipad) body.append($('<tr><td data-name="CloseLink" class="contextmenu__manualhide" onclick="ContextMenu.hide(this);return false;">' + L("CLOSE") + '</td></tr>'));
      return body;
    },

    renderItem: function (it, _panel, isTablet, event) {
      var _this = this;
      var item = {};
      $.extend(item, it);
      var proxy = _this.self;
      if (typeof proxy == "undefined")
        proxy = { item: item, menu: _this };
      if (item.jsaction) {
        item.jsaction = new Function(item.jsaction);
      }
      if (item.oncreate) {
        item.oncreate = new Function(item.oncreate);
      }
      var cont;
      var res = $("<div class='contextmenu__item'></div>");
      if (item.onCreate)
        item.onCreate.call(res, item, _this);
      if (item.oncreate) {
        var upd = item.oncreate.call(proxy);
        if (typeof upd == "object") {
          for (var i in upd) {
            item[i] = upd[i];
          }
        }
      }

      if (item.visibility === "hidden") {
        return;
      }

      if (item.text) {
        item.text = L(item.text);
      }
      item.separator = item.separator || item.bottomSeparator;
      if (item.separator) {
        res.addClass('contextmenu__item_bottomseparator');
      }
      switch (item.type) {
        /*Пункт меню - простой текст.*/
        case 'text':
          res.html("<div class='contextmenu-item-text'>" + L(item.text) + "</div>");
          break;

          /*Стандартный пункт меню.*/
        default:
          var tbl = $("<table class='contextmenu-item-table' cellpadding='0' cellspacing='0'></table>");
          if (item.href) {
            cont = $("<a href='" + item.href + "'" + (item.target ? " target='" + item.target + "'" : "") + "></a>");
            res.append(cont);
          }
          else {
            cont = res;
          }
          cont.append(tbl);

          if (item['tooltip']) tbl.attr("title", item['tooltip']);

          item['default'] = item['default'] || item.isDefault;
          item.disabled = item.disabled || item.isDisabled;
          if (item['default'])
            res.addClass('contextmenu__item_default');
          if (item.disabled)
            res.addClass("contextmenu__item_disabled");
          if (item.selected) {
            res.addClass('contextmenu__item_selected');
          }
          var tr = $("<tr></tr>");
          tbl.append(tr);


          // Иконка действия.
          item.icon = item.icon || item.image;
          item.iconx = item.iconx || item.imageX;
          item.icony = item.icony || item.imageY;
          // Иконка при наведении.
          item.hoverIcon = item.hoverIcon || item.hoverImage;
          item.hoverIconX = item.hoverIconX || item.hoverImageX;
          item.hoverIconY = item.hoverIconY || item.hoverImageY;

          var imgCell = $('<td class="contextmenu-item-table__imagecell ' + (!!item.hoverIcon ? 'hasHoverIcon' : '') + '"></td>');
          tr.append(imgCell);
          cont = imgCell;

          // Добавляем скрытую иконку при наведении.
          if (item.hoverIcon) {
            cont.append(this.renderImage(item.hoverIcon, item.hoverIconX, item.hoverIconY, item.iconHoverCSSClass, true));
          }
          // Добавляем иконку действия.
          cont.append(this.renderImage(item.icon, item.iconx, item.icony, item.iconCSSClass, false));

          var textCell = $("<td class='contextmenu-item-table__textcell'></td>").html(item.text);
          tr.append(textCell);

          if (!item.disabled) {
            var _event = _.clone(event);
            tbl.click(function (ev) {
              if (Core.isStatisticEnabled && WA.CR && WA.CR.statistics) {
                ///Запись в статистику
                WA.CR.statistics.write({
                  page: WA.getLocation(),
                  action: item.stataction || item.name || item.id || 'ContextMenuItem',
                  area: 'ContextMenu',
                  target: $(_this.targetElement).get(0) || (!!proxy.tr && proxy.tr.get(0))
                });
              };

              if (item.onClick || item.href || item.jsaction) {
                if (item.onClick) item.onClick.call(this, item, _this, _event);
                if (item.jsaction) item.jsaction.call(proxy);
                hideAllPanels();
              }
              ev.stopPropagation();
              return true;
            });
          }
          if (item.subMenu) {
            var arrowCell = $("<td class='contextmenu-item-table__arrowcell'></td>").css({ width: this.arrowWidth + "px" });
            arrowCell.append("<p class='" + this.arrowImage + " contextmenu_arrow' title='&#9654;'></p>");
            tr.append(arrowCell);
            var subPanel = $("<div class='contextmenu-container contextmenu-container__hidden'></div>").css({ zIndex: parseInt(_panel.css("zIndex"), 10) + 1 });
            item.showSubMenu = function () {
              var $this = res;
              var coords = getOffset($this);
              coords.left += $this.width() - 5;
              coords.top -= 1;
              var parentCoords = getOffset(_panel);
              coords.left -= parentCoords.left;
              coords.top -= parentCoords.top;
              item.subMenu.parentItem = item;
              item.subMenu.showAt(coords, subPanel, true);
            };
            item.hideSubMenu = function () { hidePanel(subPanel) };
            res.mouseenter(item.showSubMenu);
            res.mouseleave(item.hideSubMenu);
            res.append(subPanel);
          }
          tbl.hover(function () {
            tbl.addClass("hover");
          }, function () {
            tbl.removeClass("hover")
          });
          break;
      }
      return res;
    },
    renderImage: function (icon, iconx, icony, iconCSSClass, isHover) {
      var jIcon = null;
      if (icon) {
        var cssClass = 'contextmenu-item__icon' + (isHover ? ' contextmenu-item__icon_onhover' : '') + (iconCSSClass ? ' contextmenu-item__icon_' + iconCSSClass : '');
        if (icon.indexOf("App_Sprites") !== -1) {
          if (typeof iconx != "undefined") {
            jIcon = $('<div class="' + cssClass + '"></div>').css({ backgroundImage: "url('" + icon + "')", backgroundPosition: (-iconx) + "px " + (-icony) + "px", backgroundRepeat: "no-repeat" });
          } else {
            jIcon = $('<img class="' + cssClass + '" src="' + icon + '" />');
          }
        } else {
          jIcon = $('<svg class="' + cssClass + '"><use xlink:href="#' + icon + '"  /></svg>');
        }
      }
      return jIcon;
    },
    getCoordsFor: function (c0, _panel, useShift) {
      //var c0 = getOffset($(elem));
      var res = { left: c0.left + (useShift ? this.shiftX : 0), top: c0.top + (useShift ? this.shiftY : 0) };
      var w = _panel.width();
      var h = _panel.height();
      var ww = windowWidth();
      var scr = $('body').scrollLeft();
      if (scr) {
        ww += scr - 20;
      }
      var hh = windowHeight();

      if (res.left + w > ww - 5) {
        res.left = ww - 5 - w;
      }
      if (res.left < 0) {
        res.left = 0;
      }
      if ((res.top - $(window).scrollTop()) + h > hh && c0.top - $(window).scrollTop() - h >= 0 || res.top + h > $(window).height()) {
        res.top = c0.top - h;
      }
      return res;
    },
    lastPanelVisible: function () {
      return this.lastPanel && this.lastPanel.css("visibility") != "hidden";
    },
    getItemById: function (id) {
      var res = null;
      $.each(this.items, function () {
        if (this.id == id) {
          res = this;
          return false;
        }
      });
      return res;
    }
  })

})(jQuery);
